'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-4474431a.js');
const search_store = require('./search.store-f44567ad.js');
const index$1 = require('./index-832a679e.js');
const _package = require('./package-2c27a669.js');
const constants = require('./constants-7684cbfc.js');
const index$2 = require('./index-6d990fa6.js');

const CameraActionIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M12 17.5C13.25 17.5 14.3125 17.0625 15.1875 16.1875C16.0625 15.3125 16.5 14.25 16.5 13C16.5 11.75 16.0625 10.6875 15.1875 9.8125C14.3125 8.9375 13.25 8.5 12 8.5C10.75 8.5 9.6875 8.9375 8.8125 9.8125C7.9375 10.6875 7.5 11.75 7.5 13C7.5 14.25 7.9375 15.3125 8.8125 16.1875C9.6875 17.0625 10.75 17.5 12 17.5ZM12 15.5C11.3 15.5 10.7083 15.2583 10.225 14.775C9.74167 14.2917 9.5 13.7 9.5 13C9.5 12.3 9.74167 11.7083 10.225 11.225C10.7083 10.7417 11.3 10.5 12 10.5C12.7 10.5 13.2917 10.7417 13.775 11.225C14.2583 11.7083 14.5 12.3 14.5 13C14.5 13.7 14.2583 14.2917 13.775 14.775C13.2917 15.2583 12.7 15.5 12 15.5ZM4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H7.15L8.4 3.65C8.58333 3.45 8.80417 3.29167 9.0625 3.175C9.32083 3.05833 9.59167 3 9.875 3H14.125C14.4083 3 14.6792 3.05833 14.9375 3.175C15.1958 3.29167 15.4167 3.45 15.6 3.65L16.85 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917 22 6.45 22 7V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4Z", fill: "currentColor" })));

const UploadActionIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H19.5C19.9 3 20.25 3.15 20.55 3.45C20.85 3.75 21 4.1 21 4.5V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM6.65 17.075H17.375C17.525 17.075 17.6333 17.0083 17.7 16.875C17.7667 16.7417 17.7583 16.6083 17.675 16.475L14.75 12.575C14.6667 12.475 14.5667 12.425 14.45 12.425C14.3333 12.425 14.2333 12.475 14.15 12.575L11.15 16.45L9.125 13.675C9.04167 13.575 8.94167 13.525 8.825 13.525C8.70833 13.525 8.60833 13.575 8.525 13.675L6.375 16.475C6.275 16.6083 6.25833 16.7417 6.325 16.875C6.39167 17.0083 6.5 17.075 6.65 17.075Z", fill: "currentColor" })));

const videoStreamSettings = {
  facingMode: "environment",
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  frameRate: { ideal: 30 },
};

const checkDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};

const vviinnVpsWidgetCss = ":host{--font-family-base:Inter, system-ui, sans-serif;--font-family-mono:monospace;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--font-size-title:24px;--font-size-headline:18px;--font-size-label-large:16px;--font-size-label:14px;--font-size-body-large:16px;--font-size-body:14px;--font-size-caption:12px;--line-height-title:32px;--line-height-headline:24px;--line-height-label-large:24px;--line-height-label:20px;--line-height-body-large:24px;--line-height-body:20px;--line-height-caption:16px;--letter-spacing-title:0px;--letter-spacing-headline:0px;--letter-spacing-label-large:0px;--letter-spacing-label:0px;--letter-spacing-body-large:0px;--letter-spacing-body:0px;--letter-spacing-caption:0px;--font-weight-400:400;--font-weight-500:500;--font-weight-600:600;--font-weight-700:700;--spacing-none:0px;--spacing-25:2px;--spacing-50:4px;--spacing-75:6px;--spacing-100:8px;--spacing-125:10px;--spacing-150:12px;--spacing-200:16px;--spacing-250:20px;--spacing-300:24px;--spacing-400:32px;--spacing-500:40px;--spacing-600:48px;--border-radius-none:0px;--border-radius-25:2px;--border-radius-50:4px;--border-radius-100:8px;--border-radius-150:12px;--border-radius-200:16px;--border-radius-300:24px;--border-radius-400:32px;--border-radius-full:9999px;--stroke-width-none:0px;--stroke-width-25:1px;--stroke-width-50:2px;--stroke-width-75:3px;--stroke-width-100:4px;--stroke-width-150:6px;--stroke-width-200:8px;--stroke-width-300:12px;--product-card-widget-min-width:135px;--product-card-results-min-width:250px;--image-set-mode-min-size:155px;--product-card-set-mode-max-width:300px;--source-card-set-mode-max-width:500px;--filter-blur-none:0px;--filter-blur-100:8px;--filter-blur-150:12px;--filter-blur-200:16px;--color-bg-base:#ffffff;--color-bg-inverse:#161616;--color-border-00:#ffffff;--color-border-01:#f4f4f4;--color-border-02:#e0e0e0;--color-border-03:#c6c6c6;--color-border-inverse-00:#161616;--color-border-inverse-01:#393939;--color-field-01:#ffffff;--color-field-02:#f4f4f4;--color-icon-primary:#161616;--color-icon-secondary:#525252;--color-icon-helper:#8d8d8d;--color-icon-on-color:#ffffff;--color-icon-inverse:#ffffff;--color-icon-disabled:#16161640;--color-text-primary:#161616;--color-text-secondary:#525252;--color-text-helper:#8d8d8d;--color-text-placeholder:#a8a8a8;--color-text-on-color:#ffffff;--color-text-inverse:#ffffff;--color-text-disabled:#16161640;--button-bg-color-primary:#000000;--button-bg-color-primary-hover:#161616;--button-bg-color-primary-active:#1e1e1e;--button-bg-color-secondary:#f4f4f4;--button-bg-color-secondary-hover:#e0e0e0;--button-bg-color-secondary-active:#c6c6c6;--button-bg-color-ghost-hover:#f4f4f4;--button-bg-color-ghost-active:#eaeaea;--button-bg-color-frosted:#6f6f6f66;--button-bg-color-frosted-hover:#6f6f6f80;--button-bg-color-frosted-active:#6f6f6f99;--button-bg-color-disabled:#e0e0e0;--button-bg-color-positive:#dcfce7;--surface-bg-color-01:#f4f4f4;--surface-bg-color-01-hover:#eaeaea;--surface-bg-color-01-active:#e0e0e0;--surface-bg-color-02:#ffffff;--surface-bg-color-inverse:#262626;--surface-bg-color-inverse-hover:#303030;--surface-bg-color-inverse-active:#393939;--surface-bg-color-disabled:#e0e0e0;--chip-bg-color-primary:#161616;--chip-bg-color-primary-hover:#1e1e1e;--chip-bg-color-primary-active:#262626;--chip-bg-color-subtle:#f4f4f4;--chip-bg-color-subtle-hover:#eaeaea;--chip-bg-color-subtle-active:#e0e0e0;--chip-bg-color-outline-hover:#f4f4f4;--chip-bg-color-outline-active:#eaeaea;--label-bg-color-accent:#ff3944;}:host{display:block}.hidden{visibility:hidden;height:1px}vviinn-overlayed-modal.first-screen::part(title),vviinn-overlayed-modal.first-screen::part(secondary-action){visibility:hidden}.start-page{display:grid;grid-template-columns:repeat(2, 1fr);height:640px}#start-page_block{box-sizing:border-box;display:flex;overflow-y:auto;flex-direction:column;justify-content:center;padding:40px 62px}#start-page_block.error{align-content:center}#start-page_block vviinn-text-search{margin-top:12px}.start-page_main-content{flex-grow:1;display:flex;flex-direction:column;justify-content:center}.start-page_errors-block{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:12px}.buttons-group{display:flex;flex-direction:column;gap:12px;margin-top:24px}.action-button{display:grid;border:none;cursor:pointer;align-items:center;border-radius:8px;font-size:16px;height:48px;justify-items:center;font-family:var(--font-family, var(--font-family-base));transition:background 0.1s ease-in-out;color:#525252;background-color:#f4f4f4}.action-button:hover{background-color:#eaeaea}.action-button:first-child{background:var(--color-primary, var(--button-bg-color-primary));border-color:var(--color-primary, var(--button-bg-color-primary));color:white}.action-button:first-child:hover{background:var(--color-primary-hover, var(--button-bg-color-primary-hover));border-color:var(\n    --color-primary-hover,\n    var(--button-bg-color-primary-hover)\n  )}.action-button:active{border-color:black}.action-button-content{display:grid;align-items:center;justify-items:start;justify-content:center;font-family:var(--font-family, var(--font-family-base));grid-template-columns:max-content auto;grid-gap:8px}.action-button .hidden{display:none}.results-page{margin-top:64px;display:grid;grid-template-columns:336px auto;box-sizing:border-box}.results-page>*{padding:24px;box-sizing:border-box}.source-wrapper{display:grid;grid-template-rows:min-content 1fr;min-width:100%;overflow-y:auto;overflow-x:hidden;position:relative}.source-wrapper.text-search-wrapper{padding:24px 24px 0 24px}.filters-wrapper{margin-top:24px;overflow-x:auto;transform:translateX(-24px);min-width:calc(100% + 48px);scrollbar-width:thin;scrollbar-gutter:stable;-ms-overflow-style:none}@supports (scrollbar-color: auto){.filters-wrapper{scrollbar-color:transparent transparent}.filters-wrapper:hover{scrollbar-color:initial}}vviinn-filters{display:none}vviinn-extended-filters{display:block;position:absolute;width:100%}search-filters span{display:none}search-filters::part(filter){background:#f4f4f4;border-radius:8px;box-sizing:border-box;color:#161616;font-size:14px;font-weight:400;line-height:20px}search-filters::part(show-more-filters){display:flex;align-items:center;justify-content:center;cursor:pointer;border:1px solid #f4f4f4;min-width:40px;height:40px;border-radius:100px;box-sizing:border-box;color:#161616}search-filters::part(show-more-filters):hover{background:#eaeaea}search-filters::part(filter active){background:var(--color-primary, var(--button-bg-color-primary));color:white}.results-page:not(.active){display:none}.results-page vviinn-text-search{width:calc(100% + 24px)}vviinn-preloader{--preloader-size:24px;display:flex}@media (max-width: 1080px){#start-page_block{padding:24px 36px}}@media (max-width: 768px){.start-page{display:flex;flex-direction:column;height:100%}vviinn-overlayed-modal.first-screen::part(secondary-action){visibility:visible}.results-page vviinn-text-search{width:auto}.start-page.active{height:calc(100vh - 64px);height:calc(100svh - 64px)}.start-page:not(.active){overflow:hidden}.results-page{margin-top:0}.results-page>*{box-sizing:border-box;padding:12px 24px 24px}.source-wrapper{grid-template-rows:min-content auto;width:100%;padding:0}.source-wrapper.image-wrapper .filters-wrapper{padding-left:24px;min-width:100%}vviinn-filters{display:block;overflow:hidden}vviinn-extended-filters{display:none}.results-page{grid-template-rows:min-content;grid-template-columns:unset}#start-page_block{overflow-y:unset;min-height:-moz-fit-content;min-height:fit-content;padding:24px 20px 20px}}@media (max-width: 480px){.start-page{padding-top:0}.action-button-content{grid-gap:10px}}.visually-hidden{clip:rect(0 0 0 0);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}";

var __rest = (undefined && undefined.__rest) || function (s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
const CAMERA_START_DELAY = 500;
const VviinnVpsWidget = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
    this.globalSlotsChanged = index.createEvent(this, "globalSlotsChanged", 7);
    this.vviinnWidgetLoad = index.createEvent(this, "vviinnWidgetLoad", 7);
    this.vviinnWidgetOpen = index.createEvent(this, "vviinnWidgetOpen", 7);
    this.vviinnWidgetClose = index.createEvent(this, "vviinnWidgetClose", 7);
    this.vviinnImageCrop = index.createEvent(this, "vviinnImageCrop", 7);
    this.vviinnSelectObject = index.createEvent(this, "vviinnSelectObject", 7);
    this.vviinnSelectFilter = index.createEvent(this, "vviinnSelectFilter", 7);
    this.vviinnImageUpload = index.createEvent(this, "vviinnImageUpload", 7);
    this.vviinnNoResult = index.createEvent(this, "vviinnNoResult", 7);
    this.imageSource = null;
    this.cameraAvailable = false;
    this.isDesktop = false;
    this.videoTrack = null;
    this.isTextSearch = false;
    this.handleVviinnImageUpload = (uploadSource) => {
      this.trackInitialSearch();
      this.uploadSource = uploadSource;
    };
    this.handleVviinnImageUploadFinished = () => {
      this.handleImageSelection();
      if (this.mode === "upload" && this.showingInButton) {
        this.active = true;
      }
    };
    this.handleVviinnNoResult = (detail) => {
      if (detail.reason === "client") {
        this.wrongImageFormat = true;
      }
    };
    this.adjustCameraSettings = async () => {
      var _a;
      if (!this.videoTrack)
        return;
      const capabilities = ((_a = this.videoTrack) === null || _a === void 0 ? void 0 : _a.getCapabilities)
        ? this.videoTrack.getCapabilities()
        : {};
      if ("focusMode" in capabilities) {
        try {
          await this.videoTrack.applyConstraints({
            advanced: [{ focusMode: "continuous" }],
          });
        }
        catch (error) {
          console.error("Failed to apply focus mode constraints", error);
        }
      }
      if ("exposureMode" in capabilities) {
        try {
          await this.videoTrack.applyConstraints({
            advanced: [{ exposureMode: "continuous" }],
          });
        }
        catch (error) {
          console.error("Failed to apply exposure mode constraints", error);
        }
      }
      if ("whiteBalanceMode" in capabilities) {
        try {
          await this.videoTrack.applyConstraints({
            advanced: [{ whiteBalanceMode: "continuous" }],
          });
        }
        catch (error) {
          console.error("Failed to apply white balance mode constraints", error);
        }
      }
    };
    this.handleStartCameraClick = async () => {
      if (this.stream) {
        this.resetState();
        return;
      }
      this.cameraInitializing = true;
      setTimeout(async () => {
        this.cameraButtonClicked = true;
        try {
          const videoStream = await navigator.mediaDevices.getUserMedia({
            video: videoStreamSettings,
          });
          this.videoTrack = videoStream.getVideoTracks()[0];
          this.adjustCameraSettings();
          this.stream = videoStream;
          this.uploadSource = "startCamera";
        }
        catch (error) {
          // TODO: Show error in the UI
          console.log("Error accessing camera: ", error.message);
          this.resetState();
          this.cameraInitializing = false;
        }
      }, CAMERA_START_DELAY);
    };
    this.setShowAspectRatioError = (isError) => {
      this.showAspectRatioError = isError;
    };
    this.setTrackingDeactivated = (result) => {
      if (result.status === "rejected") {
        this.trackingDeactivated = true;
      }
    };
    this.getBasicEventData = () => {
      var _a;
      const activeCampaign = this.isTextSearch ? "TPS" : "VPS";
      return {
        widgetType: activeCampaign,
        campaignTypeId: activeCampaign,
        campaignTypeName: _package.campaignTypeNames[activeCampaign],
        widgetId: (_a = this.buttonElementId) !== null && _a !== void 0 ? _a : this.widgetElementId,
        widgetVersion: _package.version,
      };
    };
    this.LinkText = ({ href, children }) => {
      return index.h("a", { href: href || "" }, children);
    };
    this.token = undefined;
    this.active = true;
    this.currencySign = "€";
    this.locale = "de-DE";
    this.campaignId = "";
    this.excluded = "";
    this.productDetailsNewTab = true;
    this.productDetailsRedirect = true;
    this.imageResolutionWidth = 250;
    this.exampleImageSource = constants.DEFAULT_EXAMPLE_IMAGE;
    this.textSearchShow = false;
    this.addToBasketShow = false;
    this.favoriteShow = false;
    this.showOneClickDiscovery = false;
    this.addPriceContainer = false;
    this.apiPath = "https://api.vviinn.com";
    this.showingInButton = false;
    this.buttonElementId = undefined;
    this.buttonPressed = undefined;
    this.mode = "modal";
    this.resetVpsButton = undefined;
    this.replaceSlotsContentInButton = undefined;
    this.slidePosition = 0;
    this.width = 0;
    this.wrongImageFormat = false;
    this.trackingDeactivated = false;
    this.stream = null;
    this.cameraInitializing = false;
    this.cameraEnabled = false;
    this.cameraButtonClicked = false;
    this.uploadSource = undefined;
    this.showAspectRatioError = false;
    this.products = [];
    this.searchQuery = "";
  }
  initResultEvents() {
    search_store.searchState.resultLoaded = false;
    search_store.searchState.resultViewed = false;
  }
  replaceSlotsContent() {
    const slots = this.el.querySelectorAll("[slot]");
    this.globalSlotsChanged.emit({
      slots: Array.from(slots),
      element: this.el,
    });
  }
  stopStreamTracks() {
    var _a;
    (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((track) => {
      track.stop();
    });
  }
  isOnboardingSlide() {
    return this.slidePosition === 0;
  }
  isResultSlide() {
    return this.slidePosition === 1;
  }
  async componentWillLoad() {
    await index$1.instance.init({
      lng: this.locale,
      fallbackLng: "en",
      resources: index$1.resources,
    });
    _package.slotChangeListener(this, this.el);
    this.vviinnWidgetLoad.emit(this.getBasicEventData());
    this.trackWidgetEvent("load");
  }
  componentDidLoad() {
    this.replaceSlotsContent();
  }
  activeWatcher(active) {
    if (active) {
      this.overflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      this.vviinnWidgetOpen.emit(this.getBasicEventData());
      if (this.mode === "camera")
        this.handleStartCameraClick();
      this.trackWidgetEvent("open");
    }
    else {
      document.body.style.overflow = this.overflow;
      this.initResultEvents();
    }
  }
  textSearchFinishedHandler({ detail, }) {
    this.isTextSearch = true;
    this.searchQuery = detail.query;
    this.slidePosition = 1;
  }
  resultLoadHandler() {
    search_store.searchState.resultLoaded = true;
  }
  resultViewHandler() {
    search_store.searchState.resultViewed = true;
  }
  trackCameraEnabled({ detail: isEnabled }) {
    this.cameraEnabled = isEnabled;
    this.cameraInitializing = false;
  }
  trachSearchAreaChanges() {
    this.initResultEvents();
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId"]);
    const searchEvent = index$1.createSearchEvent(Object.assign({ session_id: this.uiSessionId, source: this.imageSource, search_area: "manual-selection" }, rest));
    this.trackingApi.trackEvent(searchEvent).then(this.setTrackingDeactivated);
  }
  trackDetectedObject() {
    this.initResultEvents();
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId"]);
    const searchEvent = index$1.createSearchEvent(Object.assign({ session_id: this.uiSessionId, source: this.imageSource, search_area: "attention-point" }, rest));
    this.trackingApi.trackEvent(searchEvent).then(this.setTrackingDeactivated);
  }
  trackFilterSelected({ detail }) {
    this.initResultEvents();
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId"]);
    const searchEvent = index$1.createFilterEvent(Object.assign({ session_id: this.uiSessionId, source: this.imageSource, kind: detail.kind, action: detail.action }, rest));
    this.trackingApi.trackEvent(searchEvent).then(this.setTrackingDeactivated);
  }
  connectedCallback() {
    this.isDesktop = checkDeviceType() === "desktop";
    search_store.state.apiPath = this.apiPath;
    search_store.state.currencySign = this.currencySign;
    search_store.state.locale = this.locale;
    this.cameraAvailable =
      !!navigator.mediaDevices && !!navigator.mediaDevices.getUserMedia;
    if (this.excluded) {
      this.excluded = search_store.parseExcludedToParams(this.excluded);
    }
    search_store.searchState.token = this.token;
    search_store.searchState.campaignId = this.campaignId;
    search_store.searchState.excluded = this.excluded;
    this.uiSessionId = index$1.v4();
    this.trackingApi = index$1.createTrackingApi(this.apiPath, this.token);
    this.widgetElementId = this.el.id;
  }
  trackWidgetEvent(action) {
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId", "widgetType"]);
    const eventBody = Object.assign({ action, session_id: this.uiSessionId }, rest);
    const widgetEvent = index$1.createWidgetVpsEvent(eventBody);
    this.trackingApi.trackEvent(widgetEvent).then(this.setTrackingDeactivated);
  }
  trackInitialSearch() {
    if (this.trackingDeactivated)
      return;
    const _a = this.getBasicEventData(), rest = __rest(_a, ["campaignTypeId", "widgetType"]);
    const searchEvent = index$1.createSearchEvent(Object.assign({ session_id: this.uiSessionId, search_area: "full", source: "upload" }, rest));
    this.trackingApi.trackEvent(searchEvent).then(this.setTrackingDeactivated);
  }
  handleImageSelection() {
    this.imageSource = "upload";
    this.slidePosition = 1;
    const root = this.el.shadowRoot.querySelector("vviinn-overlayed-modal");
    const overlay = root.shadowRoot.querySelector("vviinn-overlay");
    const modal = overlay.querySelector("vviinn-modal");
    const modalBody = modal.shadowRoot.querySelector(".body");
    modalBody.scrollTop = 0;
    this.stopStreamTracks();
  }
  renderButtons() {
    const isLoading = (search_store.searchState.loading &&
      search_store.searchState.searchType === "image" &&
      this.uploadSource === "startCamera") ||
      this.cameraInitializing;
    const buttons = [
      this.cameraAvailable && (index.h("button", { class: "action-button", part: "start-camera_button", onClick: () => {
          this.handleStartCameraClick();
        } }, index.h("vviinn-preloader", { class: { hidden: !isLoading } }), index.h("span", { class: { "action-button-content": true, hidden: isLoading } }, index.h("slot", { name: "vviinn-camera-icon" }, index.h(CameraActionIcon, null)), index.h("span", { class: { hidden: !this.cameraEnabled } }, index.h("slot", { name: "vviinn-camera-button-text-stop" }, index$1.instance.t("cameraButtonTextStop"))), index.h("span", { class: { hidden: this.cameraEnabled } }, index.h("slot", { name: "vviinn-camera-button-text-start" }, index$1.instance.t("cameraButtonTextStart")))))),
      index.h("vviinn-image-selector", { class: "action-button", onClick: () => (this.uploadSource = "uploadPhoto"), onVviinnImageUploadFinished: this.handleVviinnImageUploadFinished, onVviinnImageUpload: () => {
          this.handleVviinnImageUpload("uploadPhoto");
        }, onVviinnNoResult: ({ detail }) => this.handleVviinnNoResult(detail), resetVpsButton: this.resetVpsButton, basicEventData: this.getBasicEventData(), part: "upload-photo_button", startUpload: this.buttonPressed && this.showingInButton && this.mode === "upload", loading: search_store.searchState.loading &&
          search_store.searchState.searchType === "image" &&
          this.uploadSource === "uploadPhoto" }, index.h("span", { slot: "upload-button-text", class: "action-button-content" }, index.h("slot", { name: "vviinn-image-upload-icon" }, index.h(UploadActionIcon, null)), index.h("slot", { name: "vviinn-image-upload-button-text" }, index.h("span", null, index$1.instance.t("imageUploadButtonText"))))),
    ];
    return this.isDesktop ? buttons.reverse() : buttons;
  }
  resetState() {
    this.resetScroll("start-page_block");
    this.slidePosition = 0;
    search_store.searchState.resetCategoryLink = undefined;
    search_store.searchState.activeIonLink = undefined;
    search_store.searchState.image = search_store.Option.none;
    search_store.searchState.imageUrl = search_store.Option.none;
    search_store.searchState.imageBounds = search_store.Option.none;
    search_store.searchState.searchArea = search_store.Option.none;
    search_store.searchState.results = [];
    search_store.searchState.filters = [];
    search_store.searchState.dynamicFilters = [];
    search_store.searchState.detectedObjects = [];
    search_store.searchState.rectangleSearchForm = undefined;
    search_store.searchState.loading = false;
    search_store.searchState.serverError = false;
    search_store.searchState.searchType = undefined;
    this.searchQuery = "";
    this.wrongImageFormat = false;
    this.resetScroll("results-block");
    this.stopStreamTracks();
    this.initResultEvents();
    this.stream = null;
    this.cameraEnabled = false;
    this.cameraButtonClicked = false;
    this.cameraInitializing = false;
    this.setShowAspectRatioError(false);
    this.isTextSearch = false;
  }
  haveErrors() {
    return this.wrongImageFormat || search_store.searchState.serverError;
  }
  resetScroll(elementId, behavior = "auto") {
    const element = this.el.shadowRoot.getElementById(elementId);
    element === null || element === void 0 ? void 0 : element.scroll({ top: 0, left: 0, behavior });
  }
  handleModalClose() {
    this.active = false;
    this.resetState();
    const elementsToReset = ["start-page_block", "results-block"];
    elementsToReset.forEach((name) => this.resetScroll(name));
    this.trackWidgetEvent("close");
  }
  render() {
    var _a, _b;
    return (index.h(index.Host, { exportparts: `image-container, content-container, basket-button-container,brand, product-type, deeplink, currency, image, image-link, image-picture, price-container, price-amount-sale, price-amount-outdated, price-amount-regular, price-amount-base-regular, price-amount-base-sale, price-amount-base-outdated, price-outdated, price-regular, price-sale, price-prefix, title, product-card, upload-photo_button, show-files_button, start-camera_button, text-search-input, text-search-button, close-button, secondary-action, close-button, custom-label-0, custom-label-1, custom-label-2, custom-label-3, custom-label-4, energy-label-container, energy-label-icon, energy-label-product-type, energy-label-data-sheet-link ${index$2.searchWidgetFilterParts}` }, !this.showingInButton && _package.SlotSkeleton("vps"), index.h("vviinn-overlayed-modal", { class: { "first-screen": this.isOnboardingSlide() }, isFirstScreen: this.isOnboardingSlide(), active: this.active, resetState: this.resetState.bind(this), onVviinnWidgetClose: () => this.handleModalClose(), buttonElementId: (_a = this.buttonElementId) !== null && _a !== void 0 ? _a : this.widgetElementId, widgetVersion: _package.version, hideBackButton: (this.mode === "upload" && this.showingInButton) ||
        (!this.cameraEnabled && this.isOnboardingSlide()), exportparts: "secondary-action, title, close-button" }, index.h("vviinn-slider", { position: this.slidePosition }, index.h("vviinn-slide", { class: {
        "start-page": true,
        "camera-enabled": this.cameraEnabled,
      } }, index.h("vviinn-example-image", { onVviinnImageUploadFinished: this.handleVviinnImageUploadFinished, onVviinnImageUpload: () => {
        this.handleVviinnImageUpload("startCamera");
      }, basicEventData: this.getBasicEventData(), srcObject: this.stream, cameraButtonClicked: this.cameraButtonClicked, exampleImageSource: this.exampleImageSource }), index.h("div", { class: {
        error: this.haveErrors(),
      }, id: "start-page_block" }, index.h("div", { class: "start-page_main-content" }, (this.wrongImageFormat || search_store.searchState.serverError) && (index.h("div", { class: "start-page_errors-block" }, index.h("vviinn-wrong-format", { class: { hidden: !this.wrongImageFormat }, handler: () => this.resetState() }), index.h("vviinn-server-error", { class: { hidden: !search_store.searchState.serverError }, handler: () => this.resetState() }))), !this.haveErrors() && (index.h(index.Fragment, null, index.h("vviinn-teaser", null), index.h("div", { class: "buttons-group" }, this.renderButtons()), this.textSearchShow && (index.h("vviinn-text-search", { token: this.token, showInWidget: true, searchQuery: this.searchQuery, apiPath: this.apiPath, locale: this.locale }))))), index.h("vviinn-privacy-badge", { privacyBadgeText: index$1.instance.t("privacyBadgeText", {
        interpolation: { escapeValue: false },
      }), class: { invisible: this.haveErrors() } }))), index.h("vviinn-slide", { class: {
        "results-page": true,
        active: this.isResultSlide(),
      } }, this.isResultSlide() && search_store.searchState.searchType === "image" && (index.h("div", { class: "source-wrapper image-wrapper" }, index.h("vviinn-image-view", { basicEventData: this.getBasicEventData(), setShowAspectRatioError: this.setShowAspectRatioError, showAspectRatioError: this.showAspectRatioError }), index.h("div", { class: {
        "filters-wrapper": true,
        hidden: this.showAspectRatioError,
      } }, index.h("div", { class: "filters" }, search_store.searchState.filters.map((filter) => (index.h("search-filters", { filter: filter, basicEventData: this.getBasicEventData() }))))))), this.isResultSlide() && search_store.searchState.searchType === "text" && (index.h("div", { class: "source-wrapper text-search-wrapper" }, index.h("vviinn-text-search", { token: this.token, showInWidget: true, searchQuery: this.searchQuery, apiPath: this.apiPath, locale: this.locale }), index.h("div", { class: {
        "filters-wrapper": true,
        hidden: this.showAspectRatioError,
      } }, index.h("vviinn-filters", { filters: search_store.searchState.dynamicFilters, showInWidget: true, exportparts: index$2.filtersParts }), index.h("vviinn-extended-filters", { filters: search_store.searchState.dynamicFilters, mode: "preview", showHeader: false, exportparts: index$2.extendedFiltersParts, showInWidget: true, locale: this.locale })))), this.isResultSlide() && (index.h("vviinn-results", { token: this.token, uiSessionId: this.uiSessionId, apiPath: this.apiPath, widgetElementId: (_b = this.buttonElementId) !== null && _b !== void 0 ? _b : this.widgetElementId, showInWidget: true, buttonElementId: this.buttonElementId, imageResolutionWidth: this.imageResolutionWidth, "currency-sign": this.currencySign, locale: this.locale, productDetailsNewTab: this.productDetailsNewTab, productDetailsRedirect: this.productDetailsRedirect, addToBasketShow: this.addToBasketShow, favoriteShow: this.favoriteShow, showAspectRatioError: this.showAspectRatioError, trackingDeactivated: this.trackingDeactivated, resetState: this.resetState.bind(this), replaceSlotsContentInWidget: this.replaceSlotsContent.bind(this), replaceSlotsContentInButton: this.replaceSlotsContentInButton, textSearchQuery: this.searchQuery, addPriceContainer: this.addPriceContainer })))))));
  }
  get el() { return index.getElement(this); }
  static get watchers() { return {
    "active": ["activeWatcher"]
  }; }
};
VviinnVpsWidget.style = vviinnVpsWidgetCss;

exports.vviinn_vps_widget = VviinnVpsWidget;
